import { useToastStore } from '../../stores/toastStore';
import { X, CheckCircle, Info, AlertTriangle, AlertCircle } from 'lucide-react';

const icons = {
  success: <CheckCircle className="w-5 h-5 text-green-400" />,
  info: <Info className="w-5 h-5 text-cyan-400" />,
  warning: <AlertTriangle className="w-5 h-5 text-amber-400" />,
  error: <AlertCircle className="w-5 h-5 text-red-400" />,
};

const bgColors = {
  success: 'bg-green-950/90 border-green-800',
  info: 'bg-slate-900/90 border-cyan-800',
  warning: 'bg-amber-950/90 border-amber-800',
  error: 'bg-red-950/90 border-red-800',
};

export default function ToastContainer() {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 px-4 py-3 rounded-xl border shadow-lg backdrop-blur-sm min-w-[280px] animate-in slide-in-from-right ${bgColors[toast.type]}`}
        >
          {icons[toast.type]}
          <span className="text-sm flex-1">{toast.message}</span>
          <button
            onClick={() => removeToast(toast.id)}
            className="p-1 rounded hover:bg-white/10 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
